module.exports = __webpack_public_path__ + "static/gajets-2136dfb942ecdb0b44ae3a4d5cb7a05c.png";